import fetch from './fetch'

export function getUnit (id: number, content_id: number): Promise<api.unit.GetUnitResponse> {
  return fetch.get(`contents/${content_id}/units/${id}`).then(res => res.data)
}
